import type { IconNode } from '../types';

/**
 * @name towel-folded
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNyAxM2gxMGE0IDQgMCAwIDEgMCA4SDdhNCA0IDAgMCAxLTQtNFY3YTQgNCAwIDAgMSA0LTRoMTBhNCA0IDAgMCAxIDQgNHYxMCIgLz4KICA8cGF0aCBkPSJNMTcgMTdIN2E0IDQgMCAwIDEtNC00IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/towel-folded
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const towelFolded: IconNode = [
  [
    'path',
    {
      d: 'M7 13h10a4 4 0 0 1 0 8H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v10',
      key: '1egnuq',
    },
  ],
  ['path', { d: 'M17 17H7a4 4 0 0 1-4-4', key: 'yrd6ag' }],
];

export default towelFolded;
